(function () {
  // Prevents hover transitions from firing during initial paint (especially on slower devices).
  var root = document.documentElement;
  if (!root.classList.contains("vrs-ready")) {
    window.requestAnimationFrame(function () {
      root.classList.add("vrs-ready");
    });
  }
})();
